import React, { useRef, Fragment, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import AppContext from "../../../context/AppContext";
import CommonButton from "../../../components/common/CommonButton";
import translations from "../../../components/common/Translations";
import ModalCloseButton from "../../../components/common/ModalCloseButton";
import { isRTL } from "../../../utils/rtl";

export default function ExitModal({
  setExitModal,
  exitModal,
  navigateToWorkflow,
  showMsg,
  cancel_btn,
  save_btn,
  onCancel,
}) {
  const { theme, langMode } = useContext(AppContext);
  const isRtl = isRTL(langMode);
  const cancelButtonRef = useRef(null);

  const panelThemeClasses =
    theme === "dark"
      ? "dark-mode border border-red-500"
      : theme === "high-contrast"
        ? "high-contrast"
        : "";

  return (
    <Transition.Root show={exitModal} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={setExitModal}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100 translate-y-0"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <Dialog.Panel
              className={`
                relative w-full max-w-md mx-4 transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all
                ${panelThemeClasses}
              `}
            >
              <ModalCloseButton
                onClick={() => setExitModal(false)}
                ariaLabel="Close modal"
                className={`absolute top-3 ${isRtl ? "left-3" : "right-3"}`}
              />

              <h3 className="text-lg font-semibold text-gray-800 text-center mt-2">
                {translations[langMode].confirmaction}
              </h3>

              <div className="text-center mt-3 px-4">
                <Dialog.Title className="text-sm text-gray-600 leading-relaxed">
                  {showMsg}
                </Dialog.Title>
              </div>

              <div className="flex justify-end items-center gap-3 mt-6">
                <CommonButton colorIntent="danger"
                  onClick={onCancel}
                  variant="danger"
                  className="rounded-lg"
                >
                  {cancel_btn}
                </CommonButton>
                <CommonButton colorIntent="success"
                  onClick={navigateToWorkflow}
                  variant="primary"
                  className="rounded-lg"
                >
                  {save_btn}
                </CommonButton>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
